module.exports = __webpack_public_path__ + "static/media/csv.08e35b72.svg";